import {
  excelAndDbRecipeFieldsMapping,
  STRING_FIELD_MAX_LENGTH,
  TAG_FIELD_MAX_LENGTH,
} from "constant";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/helper";

/**---------------Excel validations ---------------- */

export const validateExcelHeaders = (dataArray) => {
  if (dataArray.length < 3) {
    toast.error(
      "File must include headers, dummy row, and at least one recipe!"
    );
    return false;
  }

  let headerFieldCount = 0;
  const headers = dataArray[0]; // headers are at index 0
  const requiredMappings = excelAndDbRecipeFieldsMapping.filter((m) => !m.optional);

  for (const mapping of requiredMappings) {
    const excelHeader = mapping.excelName;
    const columnIndex = headers.indexOf(excelHeader);

    if (columnIndex !== -1) {
      headerFieldCount++;
    }
  }

  if (headerFieldCount !== requiredMappings.length) {
    toast.error("Excel file is corrupted, plz download a new one!!");
    return false;
  }

  // Ensure at least one actual recipe exists beyond header and dummy
  if (dataArray.length <= 2) {
    toast.error("File is empty, plz add recipes!!");
    return false;
  }

  // Remove the dummy data at index 1
  dataArray.splice(1, 1);

  return true;
};

export const validateAndExtractCellValues = (dataArray, adminId) => {
  const extractedData = [];
  let rowErrors = {};
  const requiredFields = ["Recipe name", "Food category", "Quantity", "Unit"];
  const requiredMappingsCount = excelAndDbRecipeFieldsMapping.filter(
    (m) => !m.optional
  ).length;
  for (let i = 1; i < dataArray.length; i++) {
    const dataRow = dataArray[i];
    const recipeData = {
      adminId: adminId,
      createdAt: new Date(),
    };
    const rowErrorMessages = [];

    for (const mapping of excelAndDbRecipeFieldsMapping) {
      const excelHeader = mapping.excelName;
      const dbField = mapping.dbField;
      const columnIndex = dataArray[0].indexOf(excelHeader);

      if (columnIndex !== -1) {
        let cellValue = dataRow[columnIndex];

        // String field validation
        if (dbField in STRING_FIELD_MAX_LENGTH) {
          const maxLength = STRING_FIELD_MAX_LENGTH[dbField];
          if (typeof cellValue === "number" && !isNaN(cellValue)) {
            cellValue = cellValue.toString();
          }
          if (
            requiredFields.includes(dbField) &&
            (!cellValue || cellValue.trim() === "")
          ) {
            rowErrorMessages.push(
              getErrorMessage("INVALID_FIELD", excelHeader)
            );
          } else if (cellValue?.length > maxLength) {
            rowErrorMessages.push(
              getErrorMessage("EXCEEDS_MAX_LENGTH", excelHeader)
            );
          } else {
            recipeData[dbField] = cellValue;
          }

          // Tag field validation
        } else if (dbField in TAG_FIELD_MAX_LENGTH) {
          if (typeof cellValue === "number" && !isNaN(cellValue)) {
            cellValue = cellValue.toString();
          }
          if (
            requiredFields.includes(dbField) &&
            (!cellValue || cellValue.trim() === "")
          ) {
            rowErrorMessages.push(
              getErrorMessage("INVALID_FIELD", excelHeader)
            );
          } else {
            const maxLength = TAG_FIELD_MAX_LENGTH[dbField];
            const tagsArray = cellValue?.split(",")?.map((tag) => tag.trim());

            if (tagsArray?.some((tag) => tag.length > maxLength)) {
              rowErrorMessages.push(
                getErrorMessage(
                  "EXCEEDS_MAX_LENGTH",
                  `Tag in ${excelHeader}`,
                  i + 1
                )
              );
            } else {
              recipeData[dbField] = tagsArray;
            }
          }

          // Numeric fields
        } else if (
          dbField === "calories" ||
          dbField === "weight" ||
          dbField === "qty"
        ) {
          const numericValue = parseFloat(cellValue);
          if (cellValue && (isNaN(numericValue) || numericValue <= 0)) {
            rowErrorMessages.push(
              getErrorMessage("INVALID_NUMERIC", excelHeader)
            );
          } else {
            recipeData[dbField] = numericValue;
          }

          // Nutritions field
        } else if (dbField === "nutritions") {
          if (
            cellValue &&
            !/^(\w+\s*:\s*\d+(\.\d+)?(mg|g)\s*,\s*)*\w+\s*:\s*\d+(\.\d+)?(mg|g)\s*$/.test(
              cellValue
            )
          ) {
            rowErrorMessages.push(
              getErrorMessage("INVALID_NUTRITION_FORMAT", excelHeader)
            );
          } else {
            const nutritionComponents = cellValue
              .split(",")
              .map((item) => {
                const parts = item.split(":");
                if (parts.length !== 2) return null;

                const type = parts[0].trim();
                const valueWithUnit = parts[1].trim();

                if (!valueWithUnit) return null;

                const match = valueWithUnit.match(/^(\d+(\.\d+)?)(mg|g)$/i);
                if (!match) return null;

                const grams = parseFloat(match[1]);
                const unit = match[3];

                return { type, grams, unit };
              })
              .filter(Boolean);

            recipeData[dbField] = nutritionComponents;
          }
        }
      }
    }

    if (
      Object.keys(recipeData).length >= requiredMappingsCount + 2
    ) {
      extractedData.push(recipeData);
    } else if (rowErrorMessages.length === 0) {
      rowErrorMessages.push(getErrorMessage("INCOMPLETE_DATA"));
    }

    if (rowErrorMessages.length > 0) {
      rowErrors["rowNumber"] = i + 1;
      rowErrors["errorMessages"] = rowErrorMessages;
      break;
    }
  }

  return { extractedData, rowErrors };
};

